import React from 'react';
import { Box } from '@mui/material';
import ArogyaMitraTopbar from '../components/admin/topbar/ArogyaMitraTopbar';
import Footer from '../pages/citizen/footer';
import StickyWhatsAppButton from '../pages/citizen/components/StickyWhatsAppButton';

const ArogyaMitraLayout = ({ children }: { children: React.ReactNode }) => {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', minHeight: '100vh', position: 'relative', minWidth: '290px', overflow: 'hidden', background: "white" }} >
            <ArogyaMitraTopbar />
            <Box
                component="main"
                sx={{
                    width: '100%',
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                <Box sx={{ flexGrow: 1, borderRight: 1, borderColor: 'grey.400' }}>
                    <Box sx={{ position: 'relative', minHeight: '100%' }}>
                        {children}
                    </Box>
                </Box>
                <StickyWhatsAppButton />
                <Footer />
            </Box>
        </Box>
    );
};

export default ArogyaMitraLayout;
